export const SUPPORT_CONFIG = {
    supportArticleUrlQueryKey: "article",
}
